import { render, staticRenderFns } from "./About1dService.vue?vue&type=template&id=3080b418&scoped=true&"
import script from "./About1dService.vue?vue&type=script&lang=ts&"
export * from "./About1dService.vue?vue&type=script&lang=ts&"
import style0 from "./About1dService.vue?vue&type=style&index=0&id=3080b418&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3080b418",
  null
  
)

export default component.exports